import { Tooltip, Typography } from '@mui/material'
import { copyValue } from '@utils'

/**
 * A correlation id, shown as its first block and copied in full on click.
 *
 * These are for pasting into Messenger Pigeon or S3, not for reading: full UUIDs printed
 * in the clear out-weigh everything above them on a row, and two of them per row is most
 * of what made the lists hard to scan. Shared by the jobs and events cards so the same
 * id looks and behaves the same wherever it appears.
 */
export default function CopyableId({
    label,
    value,
}: {
    label: string
    value: string
}) {
    return (
        <Tooltip title={`${value} — click to copy`}>
            <Typography
                component="span"
                variant="caption"
                color="text.secondary"
                onClick={copyValue(value)}
                sx={{
                    fontFamily: 'monospace',
                    cursor: 'pointer',
                    '&:hover': { textDecoration: 'underline' },
                }}
            >
                {label} {value.slice(0, 8)}
            </Typography>
        </Tooltip>
    )
}
